function escapeHtmlAttribute(value: string) {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;');
}

export function createPublisherImmuTag(
  secondaryId: string | null | undefined,
  networkId: string,
  cdnUrl: string,
) {
  const normalizedCdnUrl = cdnUrl.replace(/\/+$/, '');
  const attributes = [
    secondaryId ? ` data-publisher="${escapeHtmlAttribute(secondaryId)}"` : '',
    networkId ? ` data-nid="${escapeHtmlAttribute(networkId)}"` : '',
  ].join('');

  return `<script type="text/javascript" id="immu-player" src="${escapeHtmlAttribute(normalizedCdnUrl)}/players/immu.js"${attributes} charset="utf-8" async></script>`;
}
